const CheckFollowUpIcon = ({ size = 56, className = "", isActive = false, ...props }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      {isActive ? (
        <>
          <path
            d="M28 1C42.9117 1 55 13.0883 55 28C55 42.9117 42.9117 55 28 55C13.0883 55 1 42.9117 1 28C1 13.0883 13.0883 1 28 1Z"
            fill="#68D7FF"
            fillOpacity="0.2"
          />
          <path
            d="M28 1C42.9117 1 55 13.0883 55 28C55 42.9117 42.9117 55 28 55C13.0883 55 1 42.9117 1 28C1 13.0883 13.0883 1 28 1Z"
            stroke="url(#blueGradient)"
            strokeWidth="2"
          />
        </>
      ) : (
        <>
          <rect x="1" y="1" width="54" height="54" rx="27" fill="#9EA6B2" fillOpacity="0.3" />
          <rect x="1" y="1" width="54" height="54" rx="27" stroke="url(#grayGradient)" strokeWidth="2" />
        </>
      )}

      {/* Shared icon */}
      <path
        d="M24.801 26.7653L23.2015 25.1939C22.977 24.9694 22.7151 24.8571 22.4158 24.8571C22.1165 24.8571 21.8546 24.9694 21.6301 25.1939C21.4056 25.4184 21.2889 25.6803 21.2799 25.9796C21.2709 26.2789 21.3783 26.5408 21.602 26.7653L23.9872 29.1505C24.2117 29.375 24.4785 29.4872 24.7876 29.4872C25.0966 29.4872 25.363 29.375 25.5867 29.1505L30.3571 24.4082C30.5816 24.1837 30.6939 23.9169 30.6939 23.6079C30.6939 23.2988 30.5816 23.0324 30.3571 22.8087C30.1327 22.5849 29.8663 22.4727 29.558 22.4719C29.2497 22.4712 28.9829 22.5834 28.7577 22.8087L24.801 26.7653ZM25.9796 34.9592C23.4728 34.9592 21.3495 34.0893 19.6097 32.3495C17.8699 30.6097 17 28.4864 17 25.9796C17 23.4728 17.8699 21.3495 19.6097 19.6097C21.3495 17.8699 23.4728 17 25.9796 17C28.4864 17 30.6097 17.8699 32.3495 19.6097C34.0893 21.3495 34.9592 23.4728 34.9592 25.9796C34.9592 27.0272 34.7957 28.0142 34.4687 28.9406C34.1417 29.867 33.6785 30.7133 33.0791 31.4796L38.6633 37.0638C38.8878 37.2883 39 37.555 39 37.8641C39 38.1731 38.8878 38.4395 38.6633 38.6633C38.4388 38.887 38.1724 38.9992 37.8641 39C37.5558 39.0007 37.289 38.8885 37.0638 38.6633L31.4796 33.0791C30.7126 33.6777 29.8663 34.1409 28.9406 34.4687C28.015 34.7964 27.028 34.9599 25.9796 34.9592Z"
        fill={isActive ? "#01BBFE" : "white"}
      />

      <defs>
        <linearGradient id="grayGradient" x1="3.95" y1="4.4" x2="50.76" y2="54.45" gradientUnits="userSpaceOnUse">
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>
        <linearGradient id="blueGradient" x1="3.95" y1="4.4" x2="50.76" y2="54.45" gradientUnits="userSpaceOnUse">
          <stop stopColor="#68D7FF" />
          <stop offset="1" stopColor="#68D7FF" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default CheckFollowUpIcon;
